import {
    Box,
    Container,
    Grid,
    Typography
} from "@mui/material";

import { motion } from "motion/react";

const COLORS = {
    light: "#b8e28a",
    dark: "#4e6b4d",
};

const QuienesSomos = () => {
    return (
        <Box
            sx={{
                position: "relative",
                minHeight: {
                    xs: "auto",
                    md: "90vh",
                },
                overflow: "hidden",
            }}
        >
            {/* Fondo */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: "url('/img/fotoequipo.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            />

            {/* Overlay 
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "rgba(245,248,241,0.88)",
                }}
            />*/}

            {/* Contenido */}
            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                <Grid
                    container
                    alignItems="center"
                    spacing={6}
                    sx={{
                        minHeight: {
                            xs: "auto",
                            md: "90vh",
                        },
                        py: {
                            xs: 8,
                            md: 0,
                        },
                    }}
                >
                    {/* Imagen */}
                    <Grid size={{ xs: 12, md: 5 }}>
                        <Box
                            component={motion.div}
                            initial={{
                                opacity: 0,
                                x: -80,
                            }}
                            whileInView={{
                                opacity: 1,
                                x: 0,
                            }}
                            viewport={{
                                once: true,
                            }}
                            transition={{
                                duration: 0.8,
                            }}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Box
                                component="img"
                                src="/img/quienesomos.png"
                                alt="Quiénes Somos"
                                sx={{
                                    width: {
                                        xs: "90%",
                                        sm: "75%",
                                        md: "100%",
                                    },
                                    maxWidth: 650,
                                }}
                            />
                        </Box>
                    </Grid>

                    {/* Texto */}
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Box
                            component={motion.div}
                            initial={{
                                opacity: 0,
                                x: 80,
                            }}
                            whileInView={{
                                opacity: 1,
                                x: 0,
                            }}
                            viewport={{
                                once: true,
                            }}
                            transition={{
                                duration: 0.8,
                                delay: 0.2,
                            }}
                        >
                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontWeight: 300,
                                    fontSize: {
                                        xs: "2.4rem",
                                        md: "4rem",
                                    },
                                    mb: 4,
                                    textAlign: {
                                        xs: "center",
                                        md: "left",
                                    },
                                }}
                            >
                                ¿Quiénes Somos?
                            </Typography>

                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: {
                                        xs: "1.15rem",
                                        md: "1.6rem",
                                    },
                                    lineHeight: 2,
                                    mb: 5,
                                    textAlign: {
                                        xs: "center",
                                        md: "left",
                                    },
                                }}
                            >
                                Somos una empresa de transformación
                                financiera dedicada a despertar la
                                prosperidad en México.
                            </Typography>

                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: {
                                        xs: "1.05rem",
                                        md: "1.35rem",
                                    },
                                    lineHeight: 2,
                                    textAlign: {
                                        xs: "center",
                                        md: "left",
                                    },
                                }}
                            >
                                En{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        fontWeight: 700,
                                    }}
                                >
                                    “Ready Cash”
                                </Box>
                                , creemos que el dinero es una
                                herramienta de libertad; por ello,
                                fusionamos{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        fontWeight: 700,
                                        fontStyle: "italic",
                                    }}
                                >
                                    educación financiera,
                                    motivación y servicios de ahorro,
                                    inversión y préstamos
                                </Box>{" "}
                                para que cada persona aprenda a
                                diseñar la vida abundante que merece.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default QuienesSomos;